import isFunction from 'lodash.isfunction';
import { nameOf } from '../util';
import { FINGERPRINTABLE_METADATA } from './constant';
export function Fingerprintable() {
    return ({ prototype }) => {
        if (isFunction(prototype[nameOf('getFingerprint')])) {
            Reflect.defineMetadata(FINGERPRINTABLE_METADATA, {}, prototype);
        }
    };
}
//# sourceMappingURL=Fingerprintable.js.map